import { useGet } from '../../../sharedModules/hooks/useQuery';
import { AssignableUser } from '../model';

export function useAssignableUsers(location: string) {
  return useGet<AssignableUser[]>({ url: '/collections/assignable_users', params: { location } });
}
